import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../ActionButton';
import './detail.css';

/**
 * Square icon back button that sits top-left of a page header, first item of
 * the `.dt-header__top` row (before status badges, above the title). `onDark`
 * switches to the translucent-white look for dark hero headers.
 */
const DetailBackButton = ({ onClick, label = 'Back', onDark = false }) => (
  <ActionButton
    variant='icon'
    icon='ri-arrow-left-line'
    label={label}
    onClick={onClick}
    className={`dt-header__back${onDark ? ' dt-header__back--on-dark' : ''}`}
  />
);

DetailBackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  onDark: PropTypes.bool,
};

export default DetailBackButton;
